import { AiFeedbackOption } from './aiModerationTypes';

export const AI_FEEDBACK_TYPES = {
    HARMFUL_CONTENT: 'HARMFUL_CONTENT',
    INACCURATE_CONTENT: 'INACCURATE_CONTENT',
    INCORRECT_FORMATTING: 'INCORRECT_FORMATTING',
    NO_RESPONSE: 'NO_RESPONSE',
};

export const AI_FEEDBACK_OPTIONS: AiFeedbackOption[] = [
    {
        id: AI_FEEDBACK_TYPES.HARMFUL_CONTENT,
        title: 'The content was harmful, unsafe or offensive',
        friendlyTitle: 'Harmful',
    },
    {
        id: AI_FEEDBACK_TYPES.INACCURATE_CONTENT,
        title: 'The content contained factual inaccuracies',
        friendlyTitle: 'Inaccurate',
    },
    {
        id: AI_FEEDBACK_TYPES.INCORRECT_FORMATTING,
        title: 'The formatting was incorrect',
        friendlyTitle: 'Incorrect formatting',
    },
    { id: AI_FEEDBACK_TYPES.NO_RESPONSE, title: 'Nothing was returned at all', friendlyTitle: 'No response' },
];
